/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `create` - CREATE
 * * `delete` - DELETE
 * * `update` - UPDATE
 * * `update_list_add` - UPDATE_LIST_ADD
 * * `update_list_remove` - UPDATE_LIST_REMOVE
 * * `remap_status` - REMAP_STATUS
 */
export enum OperationKind {
  CREATE = 'create',
  DELETE = 'delete',
  UPDATE = 'update',
  UPDATE_LIST_ADD = 'update_list_add',
  UPDATE_LIST_REMOVE = 'update_list_remove',
  REMAP_STATUS = 'remap_status',
}
